import util from '../util'

let controller = 'LimiteOperacao'

export default Object.assign({}, util.GetCrud(controller, ['post', 'get', 'put', 'getall', 'persist', 'delete']), {
  HistoricoLimiteOperacao: function (dto) {
    return util.Axios.GetAll(controller + '/Log', dto)
  },
  CarregarArquivoLimiteOperacao: function (dto) {
    return util.Axios.Post(controller + '/ImportacaoArquivoLimitesOperacao/CarregarArquivo', dto)
  },
  LimitesLinhaPendentesAprovacao: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/LimitesLinhaPendentesAprovacao', dto)
  },
  BuscarInformacoesArquivo: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/BuscarInformacoesArquivo',dto)
  },
  AprovarLimitesArquivo: function (dto) {
    return util.Axios.Post(controller + '/ImportacaoArquivoLimitesOperacao/Aprovar',dto)
  },
  ReprovarLimitesArquivo: function (dto) {
    return util.Axios.Post(controller + '/ImportacaoArquivoLimitesOperacao/Reprovar',dto)
  },
  GetAllSolicitacoesPendenteLimite: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/SolicitacoesPendentes', dto)
   },
  InserirArquivoModeloSolicitacao: function (dto) {
      return util.Axios.Post(controller + '/ImportacaoArquivoLimitesOperacao/InserirArquivoModeloSolicitacao', dto)
  },
  ListarArquivosModeloPaginado: function (dto, options) {
      if (options && options.data) dto.data = options.data
      return util.Axios.GetAll(controller + '/ImportacaoArquivoLimitesOperacao/ListarArquivosModeloPaginado', dto)
  },
  AprovarReprovarSolicitacao: function (id, situacao) {
    return util.Axios.Put(controller + `/${id}`, situacao)
  },
  ConsultarLimitesPix: function (dto) {
    return util.Axios.GetAll(controller + '/ConsultarLimitesPix', dto)
  },
  GetLimitesSugestaoCartao: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/GetLimitesCartaoProjecao', dto)
  },
  GetLimitesSugestaoPix: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/GetLimitesPixProjecao', dto)
  },
  GetLimiteOperacaoPorConfiguracao: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/LimiteOperacaoPorConfiguracao', dto)
  },
  Download: function (dto, options) {
  if (options && options.data) dto.data = options.data
  return util.Axios.GetBlob(controller + '/ImportacaoArquivoLimitesOperacao/Download', dto)
}
})
